export default "__VITE_ASSET__9925daf5__"